import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import DetailThreadPage from './pages/DetailThreadPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ThreadsPage from './pages/ThreadsPage';
import BottomNavbar from './components/BottomNavbar';
import AddNewThreadPage from './pages/AddNewThreadPage';
import LeaderboardsPage from './pages/LeaderboardsPage';
import { asyncPreloadProcess } from './states/preload/actions';
import Loading from './components/Loading';
import TopNavbar from './components/TopNavbar';
import MainContainer from './pages/MainContainer';

function App() {
  const { isPreload = false, authUser = null } = useSelector((states) => states);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(asyncPreloadProcess());
  }, [dispatch]);

  return !isPreload && (
  <>
    <Loading />
    <TopNavbar authUser={authUser} />
    <Routes>
      <Route element={<MainContainer />}>
        <Route />
        <Route path="/register" element={!authUser ? <RegisterPage /> : <Navigate to="/" replace />} />
        <Route path="/login" element={!authUser ? <LoginPage /> : <Navigate to="/" replace />} />
      </Route>
      <Route element={<MainContainer withSidebar />}>
        <Route path="/threads/:id" element={<DetailThreadPage />} />
        <Route path="/" element={<ThreadsPage />} />
        <Route path="/leaderboards" element={<LeaderboardsPage />} />
        <Route path="/threads/new" element={authUser ? <AddNewThreadPage /> : <Navigate to="/login" replace />} />
      </Route>
    </Routes>
    <footer className="md:hidden">
      <BottomNavbar authUser={authUser} />
    </footer>
    <Toaster />
  </>
  );
}

export default App;
